import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';

import Snack from '@/common/components/molecules/Snack/Snack';
import getQuickEntry from '@/ebat/api/products/quick-entry/getQuickEntry';

const useUpdateQuickEntry = (queryKey) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: queryKey,
    mutationFn: getQuickEntry,
    onMutate: async (data) => {
      await queryClient.cancelQueries(queryKey);

      const previousData = queryClient.getQueryData(queryKey);

      queryClient.setQueryData(queryKey, previousData);

      return { previousData, data };
    },
    onError: (error, variables, context) => {
      queryClient.setQueryData(queryKey, context.previousData);

      if (error.response.status === 500) {
        toast.error(
          <Snack message={t('common:messages:forms.errors.server_error')} />,
        );
      } else {
        toast.error(
          <Snack message={t('common:messages:forms.errors.code_error')} />,
        );
      }
    },
    onSuccess: (data) => {
      queryClient.setQueryData(queryKey, [
        ...data.map((item) => ({
          ...item,
          is_selected: false,
          id: item.id || item.sku,
          quantity:
            item.sales_packaging && !item.split_packaging
              ? item.sales_packaging
              : 1,
        })),
      ]);
    },
  });
};

export default useUpdateQuickEntry;
